module.exports = __webpack_public_path__ + "static/media/case-details-en.987a5ea7.png";